/**
 * @param {{ label: string, value?: string | number | null }[]} lines
 * @returns {string}
 */
export function bookingDetailsToText(lines) {
  return lines
    .filter(({ value }) => value != null && String(value).trim() !== '')
    .map(({ label, value }) => `${label}: ${value}`)
    .join('\n');
}
